








































































import { TranzilaToken } from '@futureecom/vue-payments'
import { useI18n } from 'vue-i18n-bridge'
import { defineComponent, computed } from '@vue/composition-api'
import type { PropType } from '@vue/composition-api'
import { styling } from './styling'
import type { Orderable, OrderableCheckout } from '@futureecom/futureecom-js/dist/services/cart-service'
import type { PaymentTranzila } from '@futureecom/futureecom-js/dist/services/payment-service'
import { useVuetify } from '@/composable/useVuetify'

export default defineComponent({
  name: 'TranzilaProvider',

  components: { TranzilaToken },

  props: {
    value: {
      type: Object as PropType<Orderable>,
      required: true,
    },
    checkout: {
      type: Object as PropType<OrderableCheckout>,
      required: true,
    },
    paymentMethod: {
      type: Object as PropType<PaymentTranzila>,
      required: true,
    },
  },

  setup() {
    const { t } = useI18n()

    const vuetify = useVuetify()
    const providerStyles = computed(() => (vuetify ? styling(vuetify) : undefined))

    return {
      t,
      providerStyles,
    }
  },
})
